export default {
  forgotPassword: {
    "title": "¿Has perdido tu contraseña?",
    "description": "Intoduce tu email y recibiras un correo eletrónico para recuperar tu contraseña",
    "submitButton": "Recuperar contraseña",
    "returnButton": "Volver",
    "requestError": 'Error en la petición, por favor intentalo mas tarde',
    "requestSuccess": 'Petición realizada con éxito, revisa tu bandeja de email'
  }
}